<template>
  <section v-if="activeStepKey === 'seller'">
    <div class="rounded-lg border border-gray-200 bg-white p-4 shadow-xs">
      <SellerForm :sellerCompleteName="sellerCompleteName" @selectedSeller="$emit('selectedSeller', $event)" />
    </div>
  </section>

  <section v-else-if="activeStepKey === 'product'">
    <div class="rounded-lg border border-gray-200 bg-white p-4 shadow-xs">
      <ProductForm
        :modelValue="product"
        :allowVirtualProduct="allowVirtualProduct"
        @update:modelValue="$emit('update:product', $event)"
        @continue="$emit('continue')"
      />
    </div>
  </section>

  <section v-else-if="activeStepKey === 'advisory'">
    <div class="rounded-lg border border-gray-200 bg-white p-4 shadow-xs">
      <AdvisoryForm
        :modelValue="advisoryAnswer"
        :availableOfferTypes="availableOfferTypes"
        @update:modelValue="$emit('update:advisoryAnswer', $event)"
        @continue="$emit('continue')"
        @cancel="$emit('cancel')"
      />
    </div>
  </section>

  <section v-else-if="activeStepKey === 'eligibility'">
    <div class="rounded-lg border border-gray-200 bg-white p-4 shadow-xs">
      <EligibilityForm @continue="$emit('eligibilityContinue', $event)" />
    </div>
  </section>

  <section v-else-if="activeStepKey === 'customer'">
    <div class="rounded-lg border border-gray-200 bg-white p-4 shadow-xs">
      <component
        :is="customerFormComponent"
        :modelValue="customer"
        :address="address"
        :address2="address.address2"
        :addressError="address.addressError"
        @update:modelValue="$emit('update:customer', $event)"
        @update:address2="$emit('update:address2', $event)"
        @newAddress="$emit('newAddress', $event)"
        @continue="$emit('continue')"
      />
    </div>
  </section>

  <section v-else-if="activeStepKey === 'actions'">
    <div class="rounded-lg border border-gray-200 bg-white p-4 shadow-xs">
      <SubscriptionSummary
        :sellerCompleteName="sellerCompleteName"
        :product="product"
        :customer="customer"
        :advisoryAnswer="advisoryAnswer"
        :address="address"
        :contractType="contractType"
        :productless="productless"
        @edit="$emit('edit', $event)"
      />
    </div>
  </section>
</template>

<script>
import SellerForm from "./SellerForm.vue";
import ProductForm from "./ProductForm.vue";
import CustomerFormLong from "./CustomerFormLong.vue";
import ProfessionalCustomerForm from "./ProfessionalCustomerForm.vue";
import AdvisoryForm from "./AdvisoryForm.vue";
import EligibilityForm from "./EligibilityForm.vue";
import SubscriptionSummary from "./SubscriptionSummary.vue";

export default {
  components: {
    SellerForm,
    ProductForm,
    CustomerFormLong,
    ProfessionalCustomerForm,
    AdvisoryForm,
    EligibilityForm,
    SubscriptionSummary,
  },
  props: {
    activeStepKey: { type: String, required: true },
    sellerCompleteName: { type: String, required: true },
    product: { type: Object, required: true },
    advisoryAnswer: { type: Object, required: true },
    customer: { type: Object, required: true },
    address: { type: Object, required: true },
    category: { type: String, default: null },
    categories: { type: Array, required: true },
    availableOfferTypes: { type: Array, default: () => [] },
    contractType: { type: String, default: null },
    productless: { type: Boolean, default: false },
    allowVirtualProduct: { type: Boolean, default: false },
  },
  emits: [
    "selectedSeller",
    "update:product",
    "update:advisoryAnswer",
    "update:customer",
    "update:address2",
    "newAddress",
    "continue",
    "cancel",
    "eligibilityContinue",
    "edit",
  ],
  computed: {
    customerFormComponent() {
      return this.advisoryAnswer?.usageType === "professional" ? "ProfessionalCustomerForm" : "CustomerFormLong";
    },
  },
};
</script>
